import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdvisorProvider } from "@/context/AdvisorContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ProductTourRouteGuard } from "@/components/ProductTourRouteGuard";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";

import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Demo from "@/pages/Demo";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Faq from "@/pages/Faq";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import SetInitialPassword from "@/pages/SetInitialPassword";
import SuperAdminPanel from "@/pages/superadmin/SuperAdminPanel";
import CanceledCompanies from "@/pages/superadmin/CanceledCompanies";
import RevenueBreakdown from "@/pages/superadmin/RevenueBreakdown";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/admin/Dashboard";
import EmployeeList from "@/pages/admin/EmployeeList";
import EmployeeNew from "@/pages/admin/EmployeeNew";
import EmployeeDetail from "@/pages/admin/EmployeeDetail";
import EmployeeHome from "@/pages/employee/EmployeeHome";
import EmployeeExpediente from "@/pages/employee/EmployeeExpediente";
import EmployeeVacation from "@/pages/employee/EmployeeVacation";
import EmployeeReceipts from "@/pages/employee/EmployeeReceipts";
import PolicyLibrary from "@/pages/admin/PolicyLibrary";
import VacationRequests from "@/pages/admin/VacationRequests";
import Announcements from "@/pages/admin/Announcements";
import TalentMap from "@/pages/admin/TalentMap";
import ReceiptsBatch from "@/pages/admin/ReceiptsBatch";
import TrainingSummary from "@/pages/admin/TrainingSummary";
import PayrollBreakdown from "@/pages/admin/PayrollBreakdown";
import AttendanceToday from "@/pages/admin/AttendanceToday";
import CompanyProfile from "@/pages/admin/CompanyProfile";
import Consulting from "@/pages/admin/Consulting";
import Nom035 from "@/pages/admin/Nom035";
import DataProcessingAgreement from "@/pages/DataProcessingAgreement";
import AuditLog from "@/pages/admin/AuditLog";
import CorrectionInbox from "@/pages/admin/CorrectionInbox";
import FailedEmailsInbox from "@/pages/admin/FailedEmailsInbox";
import Billing from "@/pages/admin/Billing";
import Jornada from "@/pages/admin/Jornada";
import WorkCenters from "@/pages/admin/WorkCenters";
import Kiosk from "@/pages/Kiosk";
import EmployeeTimeclock from "@/pages/employee/EmployeeTimeclock";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AdvisorProvider>
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/precios" element={<Pricing />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/aviso-privacidad" element={<PrivacyPolicy />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/acuerdo-tratamiento-datos" element={<DataProcessingAgreement />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/kiosko/:token" element={<Kiosk />} />
            <Route path="/verificar-correo" element={<VerifyEmail />} />
            <Route path="/crear-contrasena" element={<SetInitialPassword />} />
            <Route path="/olvide-contrasena" element={<ForgotPassword />} />
            <Route path="/restablecer-contrasena" element={<ResetPassword />} />

            <Route path="/superadmin" element={<ProtectedRoute role="super_admin"><SuperAdminPanel /></ProtectedRoute>} />
            <Route path="/superadmin/canceladas" element={<ProtectedRoute role="super_admin"><CanceledCompanies /></ProtectedRoute>} />
            <Route path="/superadmin/ingresos" element={<ProtectedRoute role="super_admin"><RevenueBreakdown /></ProtectedRoute>} />

            <Route path="/onboarding" element={<ProtectedRoute role="admin"><Onboarding /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute role="admin"><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/empleados" element={<ProtectedRoute role="admin"><EmployeeList /></ProtectedRoute>} />
            <Route path="/admin/empleados/nuevo" element={<ProtectedRoute role="admin"><EmployeeNew /></ProtectedRoute>} />
            <Route path="/admin/empleados/:id" element={<ProtectedRoute role="admin"><EmployeeDetail /></ProtectedRoute>} />
            <Route path="/admin/politicas" element={<ProtectedRoute role="admin"><PolicyLibrary /></ProtectedRoute>} />
            <Route path="/admin/vacaciones" element={<ProtectedRoute role="admin"><VacationRequests /></ProtectedRoute>} />
            <Route path="/admin/avisos" element={<ProtectedRoute role="admin"><Announcements /></ProtectedRoute>} />
            <Route path="/admin/talento" element={<ProtectedRoute role="admin"><TalentMap /></ProtectedRoute>} />
            <Route path="/admin/recibos" element={<ProtectedRoute role="admin"><ReceiptsBatch /></ProtectedRoute>} />
            <Route path="/admin/capacitacion" element={<ProtectedRoute role="admin"><TrainingSummary /></ProtectedRoute>} />
            <Route path="/admin/nomina" element={<ProtectedRoute role="admin"><PayrollBreakdown /></ProtectedRoute>} />
            <Route path="/admin/asistencia-hoy" element={<ProtectedRoute role="admin"><AttendanceToday /></ProtectedRoute>} />
            <Route path="/admin/perfil-empresa" element={<ProtectedRoute role="admin"><CompanyProfile /></ProtectedRoute>} />
            <Route path="/admin/consultoria" element={<ProtectedRoute role="admin"><Consulting /></ProtectedRoute>} />
            <Route path="/admin/nom-035" element={<ProtectedRoute role="admin"><Nom035 /></ProtectedRoute>} />
            <Route path="/admin/bitacora" element={<ProtectedRoute role="admin"><AuditLog /></ProtectedRoute>} />
            <Route path="/admin/correcciones" element={<ProtectedRoute role="admin"><CorrectionInbox /></ProtectedRoute>} />
            <Route path="/admin/envios-fallidos" element={<ProtectedRoute role="admin"><FailedEmailsInbox /></ProtectedRoute>} />
            <Route path="/admin/facturacion" element={<ProtectedRoute role="admin"><Billing /></ProtectedRoute>} />
            <Route path="/admin/jornada" element={<ProtectedRoute role="admin"><Jornada /></ProtectedRoute>} />
            <Route path="/admin/centros-de-trabajo" element={<ProtectedRoute role="admin"><WorkCenters /></ProtectedRoute>} />

            <Route path="/portal" element={<ProtectedRoute role="employee"><EmployeeHome /></ProtectedRoute>} />
            <Route path="/portal/expediente" element={<ProtectedRoute role="employee"><EmployeeExpediente /></ProtectedRoute>} />
            <Route path="/portal/vacaciones" element={<ProtectedRoute role="employee"><EmployeeVacation /></ProtectedRoute>} />
            <Route path="/portal/recibos" element={<ProtectedRoute role="employee"><EmployeeReceipts /></ProtectedRoute>} />
            <Route path="/portal/jornada" element={<ProtectedRoute role="employee"><EmployeeTimeclock /></ProtectedRoute>} />
          </Routes>
          <ProductTourRouteGuard />
          </ErrorBoundary>
          <Toaster position="top-center" />
          </AdvisorProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
